import clsx from "clsx";
import { useState } from "react";
import { Modal } from "react-bootstrap-v5";
import { MemberStatus } from "../../../../hooks/manageMembers/models/MemberStatus";
import { useMemberBans } from "../../../../hooks/manageMembers/useMemberBans";
import { GetRelativeDate } from "../../../community/utils/DateTransform";
import { ProfileMemberGrid } from "../community/ProfileMemberGrid";
import { formatDateShortIntl2 } from "../../../../helpers/FormatDate";

type Props = {
    username: string;
    status: MemberStatus;
    userId: number;
    onClose: () => void;
    onReload: () => void;
}

export const ProfileMemberBanList = ({ username, status, userId, onClose, onReload }: Props) => {
    const { list, loading, removeBan } = useMemberBans(userId);
    const [showTable, setShowTable] = useState(true);

    const _handleRemoveBan = () => {
        onClose();
        removeBan().then(() => {
            onReload();
        });
    } 
    
    return (
        <Modal 
            show 
            centered 
            size="lg"
            backdrop="static"
            contentClassName="np-pm-ban-list"
            dialogClassName="np-pm-ban-wrap"
        >
            <div className="np-pm-ban-list__header">
                <h3>Users Suspension Reason</h3>

                <button onClick={() => onClose()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path d="M16.0003 29.3327C23.3337 29.3327 29.3337 23.3327 29.3337 15.9993C29.3337 8.66602 23.3337 2.66602 16.0003 2.66602C8.66699 2.66602 2.66699 8.66602 2.66699 15.9993C2.66699 23.3327 8.66699 29.3327 16.0003 29.3327Z" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.2266 19.7732L19.7733 12.2266" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.7733 19.7732L12.2266 12.2266" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

            <h4>
                Your Highness {username}
            </h4>

            {status.details.until && (
                <span className="np-pm-ban-list__until">
                    Suspended until {formatDateShortIntl2(status.details.until)}
                </span>
            )}

            <div className="np-pm-ban-list__table">
                <div className={clsx("collapse", { 'close': !showTable })} onClick={() => setShowTable(prev => !prev)}>
                    <span>HISTORY</span>

                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M3.39959 12.541L8.83293 7.10764C9.47459 6.46598 10.5246 6.46598 11.1663 7.10764L16.5996 12.541" stroke="#151515" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                {showTable && 
                    <ProfileMemberGrid 
                        columns={[
                            {key: 'createdAt', label: 'DATE', width: '20%', getValue: v => GetRelativeDate(v.createdAt) },
                            {key: 'reason', label: 'REASON', width: '60%'},
                            {key: 'bannedByName', label: 'ADMIN', width: '20%'},
                        ]}
                        data={list}
                        loading={loading}
                        placeholder_rows={1}
                    />
                }
            </div>

            <div className="np-pm-ban-list__actions">
                <button className="secundary" onClick={() => onClose()}>
                    CANCEL
                </button>

                <button className="primary" onClick={_handleRemoveBan}>
                    Remove suspention
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                        <path d="M8.5 0.378906L12 3.38306H0" stroke="white"/>
                    </svg>
                </button>
            </div>
        </Modal>
    )
}